import { render, staticRenderFns } from "./NewsDetailsMobile.vue?vue&type=template&id=0336dae8&"
import script from "./NewsDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./NewsDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailsMobile.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports